import Chip from '@mui/material/Chip';
import DataTable, { type DataTableColumn } from '@shared/components/DataTable';
import type { AvcsCell, HoldingStatus } from '../types';

const statusColorMap: Record<HoldingStatus, 'success' | 'warning' | 'error'> = {
  active: 'success',
  expiring: 'warning',
  expired: 'error',
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

interface Props {
  cells: AvcsCell[];
  loading?: boolean;
}

export default function AvcsCellList({ cells, loading = false }: Props) {
  const columns: DataTableColumn<AvcsCell>[] = [
    {
      id: 'cellId',
      label: 'Cell ID',
      width: 100,
      render: (row) => row.cellId,
    },
    {
      id: 'cellName',
      label: 'Name',
      render: (row) => row.cellName,
    },
    {
      id: 'edition',
      label: 'Ed.',
      width: 50,
      render: (row) => row.edition,
    },
    {
      id: 'update',
      label: 'Upd.',
      width: 50,
      render: (row) => row.update,
    },
    {
      id: 'status',
      label: 'Status',
      width: 90,
      render: (row) => <Chip label={row.status} color={statusColorMap[row.status]} size="small" />,
    },
    {
      id: 'expiryDate',
      label: 'Expires',
      width: 110,
      render: (row) => formatDate(row.expiryDate),
    },
  ];

  return (
    <div data-testid="avcs-cell-list">
      <DataTable
        columns={columns}
        rows={cells}
        rowKey={(row) => row.cellId}
        loading={loading}
        emptyMessage="No AVCS cells found"
      />
    </div>
  );
}
